import './search-bar.scss';

import autoComplete from '@tarekraafat/autocomplete.js';

class SearchBar {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-search-bar',
            inputAttr: 'input',
            instanceId: '1'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$searchBar = $element;
        this.$searchBarInput = this.$searchBar.querySelector(`[${this.settings.initAttr}="${this.settings.inputAttr}_${this.settings.instanceId}"]`);
        this.$searchBarForm = this.$searchBar.querySelector('form');
        this.searchBarInputName = null;
        this.searchBarHref = this.$searchBar.getAttribute('data-href');
        this.autoCompleteJS = null;
        this.$autoCompleteWrapper = null;

        if (this.$searchBarInput) {
            this.searchBarInputName = this.$searchBarInput.getAttribute('name');

            if (this.searchBarInputName && this.searchBarHref) {
                this.initialize();
            }
        }
    }

    initialize () {
        this.autoCompleteJS = new autoComplete({ // eslint-disable-line
            selector: `[${this.settings.initAttr}="${this.settings.inputAttr}_${this.settings.instanceId}"]`,
            name: 'search-autocomplete',
            threshold: 2,
            submit: true,
            data: {
                src: async (query) => {
                    try {
                        // Fetch Data from external Source
                        const source = await fetch(`${this.searchBarHref}?${this.searchBarInputName}=${query}`);
                        // Data should be an array of `Objects` or `Strings`
                        const data = await source.json();
                        return data;
                    } catch (error) {
                        return error;
                    }
                },
                // Data source 'Object' key to be searched
                keys: ['label']
            },
            resultItem: {
                highlight: true
            },
            resultsList: {
                maxResults: 100
            },
            events: {
                input: {
                    selection: (event) => {
                        const selection = event.detail.selection.value;
                        this.autoCompleteJS.input.value = selection.label;
                        this.$searchBarForm.submit();
                    }
                }
            }
        });

        if (this.autoCompleteJS != null) {
            this.$autoCompleteWrapper = this.$searchBar.querySelector(`.${this.autoCompleteJS.name}_wrapper`);

            if (this.$autoCompleteWrapper != null) {
                this.$autoCompleteWrapper.setAttribute('aria-controls', this.autoCompleteJS.resultsList.id);
                this.$autoCompleteWrapper.setAttribute('aria-label', this.$searchBar.dataset.autocompleteAriaLabel);
            }
        }
    }
}

export { SearchBar };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$searchBar = $context.querySelectorAll('[data-search-bar="root"]');

    if ($$searchBar.length > 0) {
        $$searchBar.forEach(($searchBar, index) => {
            const searchBar = new SearchBar($searchBar, {  // eslint-disable-line
                instanceId: $searchBar.dataset.searchBarId,  // eslint-disable-line
            });  // eslint-disable-line
        });
    }
});
